import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
const BASE_URL = baseUrl +'/system' 

export default {
	/**
	 * 获取系统日志列表
	**/
	getSystemLog(params){
		params = commonJs.obj.removeNullKey(params)
		return request({
			url: BASE_URL+'/log',
			method:'get',
			params
		})
	},
	/**
	 * 删除系统日志
	**/
	systemLogDel(data){
		return request({
			url: BASE_URL+'/log',
			method:'DELETE',
			data
		})
	}
}